export default {
  EMAIL_VERIFICATION: "/api/v1/verify-email/",
  RESET_PASSWORD: "/api/v1/reset-password/",
};
